import type { NotificationPriority } from '@/types/notification';

const LABELS: Record<NotificationPriority, string> = {
  low: 'Baja',
  medium: 'Media',
  high: 'Alta',
};

type NotificationPriorityBadgeProps = {
  priority: NotificationPriority;
};

export function NotificationPriorityBadge({
  priority,
}: NotificationPriorityBadgeProps) {
  return (
    <span className={`notification-priority notification-priority--${priority}`}>
      {LABELS[priority]}
    </span>
  );
}
